import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { mapLanguageToComponentProps } from 'interview/i18n'
import { AlertBanner } from 'components/styled/alert-banner'

const propTypes = {
  i18n: PropTypes.shape({
    sequencedInterview: PropTypes.object.isRequired,
  }).isRequired,
  errorType: PropTypes.string,
  streaming: PropTypes.bool,
  testing: PropTypes.bool,
  iosUnsupported: PropTypes.bool,
  onIe: PropTypes.bool,
  opentokError: PropTypes.bool,
  customMessage: PropTypes.string,
  variant: PropTypes.string,
}

const defaultProps = {
  errorType: '',
  testing: false,
  iosUnsupported: false,
  onIe: false,
  streaming: false,
  opentokError: false,
  customMessage: '',
  variant: 'error',
}

const mapStateToProps = state => ({
  publisher: state.global.opentok.publisher,
  errorType: state.interview.sequencedInterview.errorType,
})

export class TimedInterviewError extends Component {
  getErrorMessage() {
    const {
      errorType,
      i18n,
      iosUnsupported,
      onIe,
      opentokError,
      customMessage,
    } = this.props
    const { browserInfo } = i18n.sequencedInterview

    if (iosUnsupported) {
      return browserInfo.unsupportedOnIos
    }

    if (onIe) {
      return browserInfo.ieUnsupported
    }

    if (errorType) {
      return i18n.sequencedInterview.errors[errorType]
    }

    if (opentokError) {
      return i18n.sequencedInterview.errors.generalError
    }

    if (customMessage) {
      return customMessage
    }

    return null
  }

  render() {
    const { iosUnsupported, onIe, variant, streaming } = this.props
    const errorMessage = this.getErrorMessage()
    const useInfoVariant = iosUnsupported || onIe
    const alertVariant = useInfoVariant ? 'info' : variant

    if (errorMessage && !streaming) {
      return <AlertBanner message={errorMessage} variant={alertVariant} />
    }
    return null
  }
}

TimedInterviewError.propTypes = propTypes
TimedInterviewError.defaultProps = defaultProps

export default connect(mapLanguageToComponentProps(mapStateToProps))(
  TimedInterviewError
)
